import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import { useConfig } from '../../config/ConfigProvider';

type Props = {
  children: JSX.Element;
};

const AuthProviderElement = ({ children }: Props) => {
  const config = useConfig();
  
  // Use the runtime configuration for OIDC settings
  const oidcConfig = {
    authority: config.rbLoginUrl,
    client_id: "property-management-web",
    redirect_uri: window.location.hostname !== "localhost" 
      ? `https://${window.location.hostname}` 
      : "http://localhost:3000",
    scope: "offline_access openid profile property-management",
    automaticSilentRenew: true,
    refreshTokenAllowedScope: "refresh_token",
    loadUserInfo: true,
    userStore: new WebStorageStateStore({ store: localStorage }),
    monitorSession: true,
    
    onSigninCallback: () => {
      // Store the target route without causing a full page reload
      sessionStorage.setItem('postLoginRedirect', '/association/select');
      
      // Use history API instead of window.location to avoid full page reload
      if (window.history) {
        window.history.replaceState({}, document.title, '/');
      } else {
        // Fallback for older browsers (will still cause reload)
        window.location.href = '/';
      }
    }
  };

  return (
    <AuthProvider {...oidcConfig}>
      {children}
    </AuthProvider>
  );
};

export default AuthProviderElement;
